import useStorePriority from "../../../../hooks/useStorePriority";
import { STORE_IMAGES } from "../../../../constants/urls";
import { Container, Title, Grid, Item } from "./Styled";

export default function PartnerStores() {
    const { priorityStores } = useStorePriority();

    return (
        <Container id="lojas-parceiras">
            <div>
                <Title>Lojas Parceiras</Title>
                <Grid>
                {priorityStores.map((store) => (
                    <Item key={store.slug}>
                    <img
                        src={`${STORE_IMAGES}${store.slug}.png`}
                        alt={store.name}
                    />
                    </Item>
                ))}
                </Grid>
            </div>
        </Container>
    );
}
